import { apiFetch } from './client';
import type { TabId } from '../tabs';

export type Role = 'admin' | 'editor' | 'viewer';

export interface CurrentUser {
  id: string;
  email: string;
  name: string;
  picture?: string;
  role: Role;
  tabs: TabId[];
  sections: string[];
  managerId: string | null;
  isManager: boolean;
}

export function fetchMe(signal?: AbortSignal): Promise<{ user: CurrentUser }> {
  return apiFetch<{ user: CurrentUser }>('/api/auth/me', { signal });
}

export function loginWithGoogle(idToken: string): Promise<{ user: CurrentUser }> {
  return apiFetch<{ user: CurrentUser }>('/api/auth/google', {
    method: 'POST',
    body: { idToken },
  });
}

export function logout(): Promise<{ ok: true }> {
  return apiFetch<{ ok: true }>('/api/auth/logout', { method: 'POST' });
}
